import { newsListViewStyles } from "@insite/content-library/Widgets/NewsList/NewsListView";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(newsListViewStyles, {
    ...newsListViewStyles,
    newsWrapper: {
        css: css`
            position: relative;
            border: 1px solid #e4e4ed;
            box-shadow: 0 2px 4px #e4e4ed;
            padding: 15px 15px 20px 15px;
            margin-bottom: 30px;
        `,
    },
    titleText: {
        css: css`
            border-bottom: 0;
            margin-bottom: 0;
            padding-bottom: 0;
            width: 90%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 80%;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    dateAndAuthorWrapper: {
        css: css`
            position: absolute;
            top: 15px;
            right: 15px;
            margin-bottom: 7px;
            font-size: 14px;
        `,
    },
    summaryWrapper: {
        css: css`
            margin-top: 10px;
            > div {
                span[class^="LazyImageStyle"] {
                    display: inline-block;
                    margin-right: 15px;
                    width: 7%;
                    vertical-align: top;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    width: 30%;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        );
                    }}
                }
            }
            > div > span:nth-of-type(2) {
                width: 88%;
                display: inline-block;
                font-size: 14px;
                line-height: 24px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                width: 60%;
                                padding-bottom: 20px;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    readMoreLink: {
        css: css`
            position: absolute;
            right: 15px;
            bottom: 15px;
            font-size: 14px;
        `,
    },
});
